import "./legacy";

import * as pluginus from "pluginus";
import {
    personalizationForm,
    sizeForm,
    RipeCommonsPlugin,
    RipeCommonsCapability,
    registerPlugins as registerCommonsPlugins
} from "ripe-commons-pluginus";

import { HeaderPlugin, RipeRetailMainPlugin } from "./plugins";

// registers for the onload event to run the loading of the
// the Pluginus system (start of the process)
window.onload = function() {
    if (document.getElementById("app")) {
        registerCommonsPlugins(pluginus.manager);
        HeaderPlugin.register(pluginus.manager);
        RipeRetailMainPlugin.register(pluginus.manager);

        pluginus.load();
    }
};

// sets the global plugin manager from the Pluginus system
// under the name manager on the global scope
global.manager = pluginus.manager;

// sets the global plugin name as the RIPE Retail plugin instance
// this is going to be used by 3rd party plugin implementors
global.RipeCommonsPlugin = RipeCommonsPlugin;
global.RipeCommonsCapability = RipeCommonsCapability;
global.RipeCommonsPersonalizationForm = personalizationForm;
global.RipeCommonsSizeForm = sizeForm;
